export default __webpack_public_path__ + "static/media/DaaruParty.5a45363d.mp3";